<template>
    <div>
        <FieldUpload :fileIds="['5dcbf54868d64ffa8fc76ade847d4769','1b503507aa7649c297a07d844d8a9539']"/>
        <FieldUpload :fileIds="['5dcbf54868d64ffa8fc76ade847d4769']" type="IMG"/>
    </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    },
    mounted(){
    }
}
</script>